import { render, staticRenderFns } from "./myStayModel.vue?vue&type=template&id=012f3146&scoped=true&"
import script from "./myStayModel.vue?vue&type=script&lang=js&"
export * from "./myStayModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f3146",
  null
  
)

export default component.exports